import script from "./DragMe2.vue?vue&type=script&setup=true&lang=js"
export * from "./DragMe2.vue?vue&type=script&setup=true&lang=js"

import "./DragMe2.vue?vue&type=style&index=0&id=ac3fd1f2&lang=css"

const __exports__ = script;

export default __exports__